module.exports = __webpack_public_path__ + "static/media/waterfloatingimage.be82d23b.png";